import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlugifyDirective } from './directives/slugify.directive';



@NgModule({
  declarations: [
    SlugifyDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SlugifyDirective
  ]
})
export class ContentModule { }
